import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private _router = inject(Router);


  getListPageRoute(): string {
    const currentUrl = this._router.url;
    if (currentUrl.includes('/my-approvals')) {
      return '/my-approvals';
    }
    return '/reports';
  }


  navigateToListPage(): void {
    const listRoute = this.getListPageRoute();
    this._router.navigate([listRoute]);
  }

  navigateToRecord(id: string | number): void {
    const listRoute = this.getListPageRoute();
    this._router.navigate([listRoute, id]);
  }


  navigateToActionItemCreate(queryParams: any): void {
    const listRoute = this.getListPageRoute();
    this._router.navigate([`${listRoute}/action-items/create`], { queryParams });
  }


  navigateToActionItemEdit(id: number, queryParams: any): void {
    const listRoute = this.getListPageRoute();
    this._router.navigate([`${listRoute}/action-items`, 'edit', id], { queryParams });
  }
}
